export default {
  state: {
    countries: [],
    currentUser: {},
    juridicalStatuses: [],
    scannigPacketDatabases: [],
    scanningPackets: [],
    scanningTypes: [],
    requestStatuses: [],
    notificationTypes: [],
    notificationStatuses: [],
    purchasedScanningPacket: [],
    decisionTypes: [],
    searchesInfo: [],
    activeUsersList: [],
    notificationsData: [],
    unreadNotCount: 0,
    unreadSysNotCount: 0
  },
  mutations: {
    DCRSsearches (state) {
      state.searchesInfo.searchCountAvaibled = state.searchesInfo.searchCountAvaibled - 1
    },
    setSearchesInfo (state, payload) {
      state.searchesInfo = payload
    },
    setActiveUsersList (state, payload) {
      state.activeUsersList = payload
    },
    setNotificationTypes (state, payload) {
      state.notificationTypes = payload
    },
    setNotificationStatuses (state, payload) {
      state.notificationStatuses = payload
    },
    setNotificationData (state, payload) {
      state.notificationsData = payload
    },
    setCurrentUserDetails (state, payload) {
      state.currentUser = payload
    },
    setPurchasedScanningPacket (state, payload) {
      state.purchasedScanningPacket = payload
    },
    setCountryList (state, payload) {
      state.countries = payload
    },
    setjuridicalStatuses (state, payload) {
      state.juridicalStatuses = payload
    },
    setscannigPacketDatabases (state, payload) {
      state.scannigPacketDatabases = payload
    },
    setscanningPackets (state, payload) {
      state.scanningPackets = payload
    },
    setscanningTypes (state, payload) {
      state.scanningTypes = payload
    },
    setRequestStatuses (state, payload) {
      state.requestStatuses = payload
    },
    setDecisionTypes (state, payload) {
      state.decisionTypes = payload
    },
    deleteNotifications (state) {
      state.notificationsData = []
    },
    setUnreadNotCount (state, payload) {
      state.unreadNotCount = payload
    },
    setUnreadSysNotCount (state, payload) {
      state.unreadSysNotCount = payload
    },
    resetUnreadCounts (state) {
      state.unreadNotCount = 0
      state.unreadSysNotCount = 0
    },
    markNotificationAsRead (state, payload) {
      state.unreadNotCount--
      state.notificationsData.forEach(element => {
        if (element.id === payload) {
          element.status = 1
        }
      })
    }
  },
  actions: {
    markNotificationAsRead ({ commit }, payload) {
      commit('markNotificationAsRead', payload)
    }
  },
  getters: {
    GetSearchesInfo (state) {
      return state.searchesInfo
    },
    GetActiveUsersList (state) {
      return state.activeUsersList
    },
    GetNotificationStatuses (state) {
      return state.notificationStatuses
    },
    GetnotificationTypes (state) {
      return state.notificationTypes
    },
    GetNotificationData (state) {
      return state.notificationsData
    },
    GetPurchasedScanningPacket (state) {
      return state.purchasedScanningPacket
    },
    GetCurrentUser (state) {
      return state.currentUser
    },
    GetCountriesList (state) {
      return state.countries
    },
    GetjuridicalStatuses (state) {
      return state.juridicalStatuses
    },
    GetscannigPacketDatabases (state) {
      return state.scannigPacketDatabases
    },
    getFilteredPacketDatabases (state) {
      var ppack = state.purchasedScanningPacket
      return key => state.scannigPacketDatabases.filter(
        sdb =>
          (sdb.juridicalStatusId === 0 || sdb.juridicalStatusId === key) && sdb.scanningPacketID === ppack.scanningPacketId
      )
    },
    GetscanningPackets (state) {
      return state.scanningPackets
    },
    GetscanningTypes (state) {
      return state.scanningTypes
    },
    GetRequestStatuses (state) {
      return state.requestStatuses
    },
    GetDecisionTypes (state) {
      return state.decisionTypes
    },
    GetUnreadNotiCount (state) {
      return state.unreadNotCount
    },
    GetUnreadSysNotiCount (state) {
      return state.unreadSysNotCount
    }
  }
}
